function initializePostscriptPopup() {
    if (!window.postscript || typeof window.postscript !== "object" ||
        typeof window.postscript.popups?.open !== "function") {
        return; // Postscript SDK isn't fully ready
    }

    function attachClickEvent(link) {
        link.addEventListener("click", function(event) {
            event.preventDefault(); // Prevent default link behavior
            window.postscript.popups.open("02751265-a8c5-4c2e-958f-5ec7062f232c", {
                activePopupBehavior: 'ALWAYS_DISMISS',
                respectPopupStatus: false
            });
        });
    }

    let link = document.getElementById("postscript-popup-link-fr");

    if (link) {
        attachClickEvent(link);
    } else {
        // Wait for the link to be added to the DOM
        const observer = new MutationObserver((mutations, obs) => {
            link = document.getElementById("postscript-popup-link-fr");
            if (link) {
                attachClickEvent(link);
                obs.disconnect(); // Stop observing once link is found
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
}

// Check if Postscript SDK is available
if (window.postscript && typeof window.postscript === "object" &&
    typeof window.postscript.popups?.open === "function") {
    initializePostscriptPopup();
} else {
    // Wait for Postscript to be ready
    window.addEventListener("postscriptReady", initializePostscriptPopup);
}